/**
 * What a contract's status is called on screen. Legal's task list, the
 * contract list, the department head's list and the contract page all label
 * contracts from here, so one contract carries one name wherever legal meets
 * it. The names follow legal's task list, which is where legal works from.
 */

export const CONTRACT_STATUS_LABELS = {
  pending_upload: 'Prequalified and Pending Contract Upload',
  active: 'Active',
  expiring_soon: 'Expiring Soon',
  expired: 'Expired',
  recalled: 'Awaiting Correction',
  termination_recommended: 'Termination Recommended',
  terminated: 'Terminated',
  renewed: 'Renewed',
};

// The list filter, in the order a contract moves through them. expiring_soon
// and expired are worked out from the end date, see displayContractStatus.
export const CONTRACT_STATUS_OPTIONS = [
  'pending_upload',
  'active',
  'expiring_soon',
  'expired',
  'recalled',
  'termination_recommended',
  'terminated',
].map((value) => ({ value, label: CONTRACT_STATUS_LABELS[value] }));

const DAY_MS = 1000 * 60 * 60 * 24;

/**
 * The status to show: an active contract reads as expiring soon within 30 days
 * of its end date, and as expired past it, before the renewal job has stored
 * that.
 */
export const displayContractStatus = (contract, now = Date.now()) => {
  const status = contract?.status || 'pending_upload';
  if (status !== 'active' || !contract.endDate) return status;
  const daysLeft = Math.ceil((new Date(contract.endDate).getTime() - now) / DAY_MS);
  if (daysLeft <= 0) return 'expired';
  if (daysLeft <= 30) return 'expiring_soon';
  return status;
};

export const contractStatusLabel = (status) =>
  CONTRACT_STATUS_LABELS[status] || String(status || '').replace(/_/g, ' ').replace(/^\w/, (c) => c.toUpperCase());

// A department head lists their department's contracts but does not open one:
// the contract page carries the commercial terms and the supplier's documents.
// The server refuses the contract to them as well.
export const canOpenContract = (user) => Boolean(user?.role) && user.role !== 'management';
